// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cHvR","textarea":"styles_textarea__3r1iT"};